import React, { Component, Fragment } from 'react';
import { NavLink } from 'react-router-dom'
import { BASE_PATH } from "../../../../../wpconfig";
import ReactPaginate from "react-paginate";

class RAuthors extends Component {
	constructor(props) {
		super(props);

		const arr = [];
		// 새로운 구조: 배열인 경우
		if (Array.isArray(this.props.record.author)) {
			arr.push(...this.props.record.author);
		}
		// 기존 구조: 객체인 경우 (하위 호환성)
		else if (this.props.record.author && typeof this.props.record.author === 'object') {
			Object.keys(this.props.record.author).map((item, index) => {
				if (Array.isArray(this.props.record.author[item])) {
					this.props.record.author[item].map((item2, index2) => {
						arr.push(item2);
					});
				}
			});
		}

		this.state = {
			activeTab: 'list',
			current_page: 1,
			itemsPerPage: 10,
			listRecords: arr
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.record !== this.props.record) {
			const arr = [];
			// 새로운 구조: 배열인 경우
			if (Array.isArray(this.props.record.author)) {
				arr.push(...this.props.record.author);
			}
			// 기존 구조: 객체인 경우 (하위 호환성)
			else if (this.props.record.author && typeof this.props.record.author === 'object') {
				Object.keys(this.props.record.author).forEach((item) => {
					if (Array.isArray(this.props.record.author[item])) {
						this.props.record.author[item].forEach((item2) => {
							arr.push(item2);
						});
					}
				});
			}
			this.setState({
				listRecords: arr,
				current_page: 1, // 새 데이터로 바뀌었으면 첫 페이지로
			});
		}
	}

	changeTab = (id) => {
		this.setState({
			activeTab: id
		})
	}

	handlePageClick = (page) => {
		const paged = page.selected + 1;

		this.setState({
			current_page: paged
		})
	}

	render() {
		const record = this.props.record;

		if (!record || !record.author)
			return ''
		else if (Array.isArray(record.author) && record.author.length <= 0)
			return ''
		else if (!Array.isArray(record.author) && typeof record.author === 'object' && Object.keys(record.author).length <= 0)
			return ''

		return (
			<React.Fragment>
				{record.author &&
					<div className="mt-4 pt-px-40 border-top border-lightgray">
						<div className="d-flex justify-content-between align-items-center mb-px-26">
							<div className="d-flex align-items-center">
								<h3 className="con-title">저자</h3>
							</div>
						</div>
						<div className="d-flex align-items-center mb-3">
							<button
								onClick={() => this.changeTab('list')}
								className={"btn-tab-nav mr-1 active-color-lightblue " + (this.state.activeTab === 'list' ? 'active' : '')}>리스트
							</button>
							<button
								onClick={() => this.changeTab('only')}
								className={"btn-tab-nav mr-1 active-color-lightblue " + (this.state.activeTab === 'only' ? 'active' : '')}>Only
								PNU
							</button>
							<button
								onClick={() => this.changeTab('org')}
								className={"btn-tab-nav mr-1 active-color-lightblue " + (this.state.activeTab === 'org' ? 'active' : '')}>기관별
							</button>
						</div>
						<div>
							{this.state.activeTab === 'list' &&
								<div className="tab-data active">
									<table className="table table-lightgray">
										<colgroup>
											<col width="6%" />
											<col width="21%" />
											<col width="25%" />
											<col width="25%" />
											<col width="23%" />
										</colgroup>
										<thead>
											<tr>
												<th scope="col">No.</th>
												<th scope="col" className="text-left">저자명</th>
												<th scope="col" className="text-left">기관명</th>
												<th scope="col" className="text-left">소속</th>
												<th scope="col">역할</th>
											</tr>
										</thead>
										<tbody>
											{record.author && this.state.listRecords.slice((this.state.current_page - 1) * this.state.itemsPerPage, this.state.current_page * this.state.itemsPerPage).map((item, index) => {
												return (
													<tr key={record.resource_id + index}>
														<td className="">
															{((this.state.current_page - 1) * this.state.itemsPerPage) + (index + 1)}</td>
														<td className="text-left">
															<NavLink to={BASE_PATH + "scholar/?record_id=" + item.scholar_id}>
																<strong className="color-lightblue">{item.author_name}</strong>
															</NavLink>
														</td>
														<td className="text-left">{item.org_name}</td>
														<td className="text-left">{item.dept_name}</td>
														<td className="">{item.author_role}</td>
													</tr>
												)
											})}
										</tbody>
									</table>
									{/* 페이지네이션 */}
									{Object.keys(this.state.listRecords).length > 10 &&
										<div className="mt-4">
											<div>
												<div className="paging-wrap">
													<ReactPaginate
														forcePage={this.state.current_page - 1}
														pageCount={Math.ceil(this.state.listRecords.length / this.state.itemsPerPage)}
														marginPagesDisplayed={2}
														pageRangeDisplayed={10}
														onPageChange={this.handlePageClick}
														containerClassName={'pagination'}
														activeClassName={'active'}
														pageClassName={'page-item'}
														pageLinkClassName={'page-link'}
														previousClassName={'page-item page-item-prev'}
														previousLinkClassName={'page-link'}
														nextClassName={'page-item page-item-next'}
														nextLinkClassName={'page-link'}
													/>
												</div>
											</div>
										</div>
									}
								</div>
							}
							{this.state.activeTab === 'org' &&
								<div className="tab-data active">
									<div className="pt-4 pb-4 border-top border-bottom border-lightgray">
										{(() => {
											// 기관별로 그룹핑
											const groupedByOrg = {};

											// 새로운 구조: 배열인 경우
											if (Array.isArray(record.author)) {
												record.author.forEach((author) => {
													const orgName = author.org_name || '기타';
													if (!groupedByOrg[orgName]) {
														groupedByOrg[orgName] = [];
													}
													groupedByOrg[orgName].push(author);
												});
											}
											// 기존 구조: 객체인 경우
											else if (record.author && typeof record.author === 'object') {
												Object.keys(record.author).forEach((orgName) => {
													if (Array.isArray(record.author[orgName])) {
														groupedByOrg[orgName] = record.author[orgName];
													}
												});
											}

											return Object.keys(groupedByOrg).map((orgName, index) => {
												return (
													<div key={index} className={index > 0 ? "mt-4" : ""}>
														<h3 className="detail-title mb-2">{orgName}</h3>
														<div className="font-size-14 color-lightblack">
															{groupedByOrg[orgName].map((item2, index2) => {
																let c = item2.scholar_id ? 'color-lightblue' : ''
																return (
																	<Fragment key={index2}>
																		{item2.scholar_id ? <NavLink to={BASE_PATH + "scholar/?record_id=" + item2.scholar_id}>
																			<strong className={c}>{item2.author_name}</strong></NavLink> :
																			<strong>{item2.author_name}</strong>}
																		<span className="color-lightblack">
																			({item2.dept_name || ''})
																			{groupedByOrg[orgName].length - 1 > index2 ? ', ' : ''}
																		</span>
																	</Fragment>
																)
															})}
														</div>
													</div>
												)
											});
										})()}
									</div>
								</div>
							}
							{this.state.activeTab === 'only' &&
								<div className="tab-data active">
									<div className="pt-4 pb-4 border-top border-bottom border-lightgray">
										<div>
											<h3 className="detail-title mb-2">부산대학교</h3>
											{(() => {
												let pnuAuthors = [];

												// 새로운 구조: 배열인 경우
												if (Array.isArray(record.author)) {
													pnuAuthors = record.author.filter(author =>
														author.org_name === '부산대학교' ||
														author.org_name === 'Pusan National University' ||
														author.authority_org_name === 'Pusan National University' ||
														author.authority_org_name_kor === '부산대학교'
													);
												}
												// 기존 구조: 객체인 경우
												else if (record.author && typeof record.author === 'object') {
													if (record.author['부산대학교'] && Array.isArray(record.author['부산대학교'])) {
														pnuAuthors = record.author['부산대학교'];
													}
												}

												return pnuAuthors.map((item, num) => {
													return (
														<div className="font-size-14 mt-2" key={num}>
															{item.scholar_id ? (
																<NavLink to={BASE_PATH + "scholar/?record_id=" + item.scholar_id}>
																	<strong className="color-lightblue">{item.author_name}</strong>
																</NavLink>
															) : (
																<strong>{item.author_name}</strong>
															)}
															<span className="color-lightblack">
																({(item.col_name ? item.col_name : '') + (item.dept_name ? ', ' + item.dept_name : '')
																	+ (item.maj_name ? ', ' + item.maj_name.trim() : '')}
																{/*{item.sinbun_name ? ' | ' + item.sinbun_name : ''}*/}
																{item.author_role ? <span className="text-success pl-1"> {item.author_role} </span> : ''}
																)
															</span>
														</div>
													)
												});
											})()}
										</div>
									</div>
								</div>
							}
						</div>
					</div>
				}
			</React.Fragment>
		)
	}
};

export default RAuthors;
